import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { base64 } from '@firebase/util';
import { FrontAPI, AuthService, SystemVatResponseDTO, SystemVAT, SystemConfigResponseDTO, SystemConfig } from "@easyfo/common-lib";

@Injectable({
    providedIn: 'root',
})
export class FrontService {
    constructor(
        private frontAPI: FrontAPI,
        private cookieService: CookieService,
        private authService: AuthService
    ) { }

    requestSystemVat(hotelId: string, callback: any) {
        let jwt = base64.decodeString(this.cookieService.get('authorized'), false);
        this.frontAPI.requestVat(jwt, hotelId).subscribe({
            next: (response: SystemVatResponseDTO) => {
                if (response.success == true) {
                    let data: SystemVAT = response.data;
                    let expired = base64.decodeString(this.cookieService.get("expired"), false);
                    let expiredDate = new Date(expired);
                    this.cookieService.set("vat", base64.encodeString(data.vat.toString()), { expires: expiredDate, path: '/', domain: location.hostname });
                    callback();
                }
            },
            error: (error) => {
                if (this.authService.handleSessionExpired(error) == true) {
                    return;
                }
                callback();
            }
        });
    }

    requestAllSystemConfig(hotelId: string, callback: any) {
        let jwt = base64.decodeString(this.cookieService.get('authorized'), false);
        this.frontAPI.requestSystemConfig(jwt, hotelId).subscribe({
            next: (response: SystemConfigResponseDTO) => {
                if (response.success == true) {
                    let data: SystemConfig = response.data;
                    let expired = base64.decodeString(this.cookieService.get("expired"), false);
                    let expiredDate = new Date(expired);
                    this.cookieService.set("vat", base64.encodeString(data.vat.toString()), { expires: expiredDate, path: '/', domain: location.hostname });
                    this.cookieService.set("nmfc", base64.encodeString(data.forecast_num.toString()), { expires: expiredDate, path: '/', domain: location.hostname });
                    callback();
                }
            },
            error: (error) => {
                if (this.authService.handleSessionExpired(error) == true) {
                    return;
                }
                callback();
            }
        });
    }

    requestCloseDayCheck(hotelId?: string): Promise<{ state: number, userId: string, userName: string, allow: boolean }> {
        return new Promise((resolve, reject) => {
            let jwt = base64.decodeString(this.cookieService.get('authorized'), false);
            let hotelIdCookie = base64.decodeString(this.cookieService.get('hid'), false);
            let uid = base64.decodeString(this.cookieService.get('uid'), false);
            let hid = hotelId;
            if (!hid) {
                hid = hotelIdCookie;
            }
            this.frontAPI.requestCloseDayState(jwt, hid!).subscribe({
                next: (response: any) => {
                    if (response.success == true && response.data && response.data.closeday_status) {
                        resolve({ state: response.data.closeday_status, userId: response.data.user_id, userName: response.data.user_name, allow: Boolean(uid == response.data.user_id) });
                    } else if (response.success == true) {
                        resolve({ state: 0, userId: '', userName: '', allow: false });
                    }
                },
                error: (error) => {
                    if (this.authService.handleSessionExpired(error) == true) {
                        return;
                    }
                    reject();
                }
            });
        });
    }

    cancelCloseDayClick(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let jwt = base64.decodeString(this.cookieService.get('authorized'), false);
            let hotelId = base64.decodeString(this.cookieService.get('hid'), false);
            this.frontAPI.requestCancelCloseDay(jwt, hotelId).subscribe({
                next: (response: any) => {
                    if (response.success == true) {
                        resolve(true);
                    } else if (response.success == true) {
                        resolve(false);
                    }
                },
                error: (error) => {
                    if (this.authService.handleSessionExpired(error) == true) {
                        return;
                    }
                    reject();
                }
            });
        });
    }

    getHotelName() {
        return base64.decodeString(this.cookieService.get('hname'), false);
    }
    
}
